import { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  TableContainer
} from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const EmployeeListResults = ({ employees, onPaginationChange, totalCount, refreshTable, isDashboard, ...rest }) => {
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [limit, setLimit] = useState(isDashboard ? 10 : 25);
  const [page, setPage] = useState(0);

  const handleSelectAll = (event) => {
    let newSelectedEmployeeIds;

    if (event.target.checked) {
      newSelectedEmployeeIds = employees.map((employee) => employee.requestId);
    } else {
      newSelectedEmployeeIds = [];
    }

    setSelectedEmployeeIds(newSelectedEmployeeIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedEmployeeIds.indexOf(id);
    let newSelectedEmployeeIds = [];

    if (selectedIndex === -1) {
      newSelectedEmployeeIds = newSelectedEmployeeIds.concat(selectedEmployeeIds, id);
    } else if (selectedIndex === 0) {
      newSelectedEmployeeIds = newSelectedEmployeeIds.concat(selectedEmployeeIds.slice(1));
    } else if (selectedIndex === selectedEmployeeIds.length - 1) {
      newSelectedEmployeeIds = newSelectedEmployeeIds.concat(selectedEmployeeIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedEmployeeIds = newSelectedEmployeeIds.concat(
        selectedEmployeeIds.slice(0, selectedIndex),
        selectedEmployeeIds.slice(selectedIndex + 1)
      );
    }

    setSelectedEmployeeIds(newSelectedEmployeeIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    onPaginationChange('limit', event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    onPaginationChange('page', newPage);
  };

  return (
    <Card {...rest} elevation={0} sx={{
      px: 2
    }}>
      <PerfectScrollbar>
        <Box sx={isDashboard ? {minWidth: 950}: { minWidth: 1650 }}>
          <TableContainer sx={{maxHeight: 500}}>
          <Table stickyHeader aria-label="Employee Lsit" id="employee-list">
            <TableHead>
              <TableRow>
                {!isDashboard ? <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedEmployeeIds.length === employees.length}
                    color="primary"
                    icon={<RadioButtonUncheckedIcon/>}
                    checkedIcon={<CheckCircleIcon/>}
                    indeterminate={
                      selectedEmployeeIds.length > 0
                      && selectedEmployeeIds.length < employees.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell> : null}
                <TableCell sx={{width: 115}}>
                  Employee ID
                </TableCell>
                <TableCell>
                  Appointment ID
                </TableCell>
                <TableCell>
                  Name
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Phone
                </TableCell>
                <TableCell>
                  Appointment Date
                </TableCell>
                {!isDashboard ? <TableCell>
                  Provider Name
                </TableCell> : null}
                <TableCell>
                  Current Status
                </TableCell>
                <TableCell>
                  Gender
                </TableCell>
                <TableCell>
                  Camp Type
                </TableCell>
                <TableCell>
                  Age
                </TableCell>
                <TableCell>
                  Dose Info
                </TableCell>
                <TableCell>
                  Location
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {employees.slice(0, limit).map((employee) => (
                <TableRow
                  hover
                  key={employee.requestId}
                  selected={selectedEmployeeIds.indexOf(employee.requestId) !== -1}
                >
                  {!isDashboard ? <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      icon={<RadioButtonUncheckedIcon/>}
                      checkedIcon={<CheckCircleIcon/>}
                      checked={selectedEmployeeIds.indexOf(employee.requestId) !== -1}
                      onChange={(event) => handleSelectOne(event, employee.requestId)}
                      value="true"
                    />
                  </TableCell> : null}
                  <TableCell>
                    {employee.employeeId}
                  </TableCell>
                  <TableCell>
                    {employee.AppointmentId}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {employee.patientName}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {employee.emailId}
                  </TableCell>
                  <TableCell>
                    {employee.phoneNumber}
                  </TableCell>
                  <TableCell>
                    {moment(employee.appointmentDate).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    {employee.appointmentStatus}
                  </TableCell>
                  {!isDashboard ? <TableCell>
                    {employee.providerName}
                  </TableCell> : null}
                  <TableCell>
                    {employee.currentStatusName}
                  </TableCell>
                  <TableCell>
                    {employee.gender}
                  </TableCell>
                  <TableCell>
                    {employee.campType}
                  </TableCell>
                  <TableCell>
                    {employee.age}
                  </TableCell>
                  <TableCell>
                    {employee.doseInfo ? employee.doseInfo: 'Nil'}
                  </TableCell>
                  <TableCell>
                    {employee.clientLocation}
                  </TableCell>
                  <TableCell>
                    {employee.dcName}
                  </TableCell>
                  <TableCell>
                    {employee.dcLocation}
                  </TableCell>
                  <TableCell>
                    {employee.testName}
                  </TableCell>
                  <TableCell>
                    {employee.corporateName}
                  </TableCell>
                  <TableCell>
                    {employee.AppointmentConfirmationDate}
                  </TableCell>
                  <TableCell>
                    {employee.appointmentConfirmationTAT}
                  </TableCell>
                  <TableCell>
                    {employee.appointmentRescheduleDate1}
                  </TableCell>
                  <TableCell>
                    {employee.appointmentRescheduleDate2}
                  </TableCell>
                  <TableCell>
                    {employee.appointmentRescheduleDate3}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </TableContainer>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={totalCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Card>
  );
};

EmployeeListResults.propTypes = {
  employees: PropTypes.array.isRequired,
  onPaginationChange: PropTypes.func
};

export default EmployeeListResults;
